import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=36e5e2ae&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e5e2ae')) {
      api.createRecord('36e5e2ae', component.options)
    } else {
      api.reload('36e5e2ae', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=36e5e2ae&", function () {
      api.rerender('36e5e2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ws4F1kdKW5tW/JS/comp/IncreaseNumber.vue"
export default component.exports